import { createLegacyModule } from "./createLegacyModule";

const keys = [
  "Address",
  "again Take number",
  "Are you sure you want to cancel your queue number?",
  "beingQueuing",
  "call_Calling",
  "call_Current",
  "call_tables",
  "callCancelled",
  "callPassed",
  "callSeated",
  "Cancel",
  "Cancel line up",
  "Confirm_",
  "Continue",
  "Currently queuing",
  "Enter a correct Phone Number",
  "Enter your last 4-digits of phone number",
  "Enter your last 4-digits of phone number_",
  "Enter your phone number",
  "Failed to get the number, please try again",
  "Get number",
  "Getting number successfully",
  "Getting the number online and receiving notice",
  "Have dinner",
  "It's time to eat!",
  "Line up the details",
  "Next",
  "Notice",
  "Order time",
  "Party size",
  "people",
  "Previous",
  "promptlySave",
  "Queue",
  "Queue System",
  "Save credentials",
  "Screenshot to save the number",
  "Sign in_",
  "Take number",
  "Take number succeeded",
  "The number has expired, please get it again",
  "There are active numbers",
  "Unable to access the page, please check the link for errors",
  "Unable to access the page, please try again",
  "Waiting",
  "Welcome Guest",
  "WhatsApp prompts the latest trends of queuing",
  "Whatsapp for queue status",
  "will be coming soon",
  "You'll be there soon",
  "You have confirmed"
];

export default createLegacyModule(keys);
